import type { ProjectStatus } from '@awork/features/project/models/project-status.model'
import type { SelectOption } from '@awork/_shared/models/select-option.model'

/**
 * The project type in awork
 */
export class ProjectType {
  id: string
  name: string
  description: string
  icon: string
  isArchived: boolean
  projectStatuses?: ProjectStatus[]
  createdOn: string | Date
  createdBy: string
  updatedOn: string | Date
  updatedBy: string
  typeName = 'ProjectType'

  constructor(type: Partial<ProjectType>) {
    Object.assign(this, type)
  }

  static isProjectType(projectType: unknown): projectType is ProjectType {
    return (projectType as ProjectType)?.typeName === 'ProjectType'
  }

  get urlName(): string {
    return decodeURIComponent(this.name.replace(/ /g, '-'))
  }

  static getProjectTypeOptions(projectTypes: ProjectType[], filter?: ProjectType): SelectOption[] {
    let options = projectTypes.map(types => ({
      value: types.id,
      label: types.name,
      icon: types.icon
    }))

    if (filter) {
      options = options.filter(type => type.value !== filter.id)
    }

    return options
  }
}
